import VueBaseController from '../vue_base'

// eslint-disable-next-line import/prefer-default-export
export class ShowController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/admin/link_opportunity_settings/show.vue')
  }
}
